<mat-card>
  <div class="link">
    <h1>
      {{
        data?.is_partner
          ? "感谢您的合作与推广"
          : "推荐朋友购买立享首单10%返现(成为经销商获取更多佣金)"
      }}
    </h1>

    <div class="sharelink">
      {{ sharelink() }}
      <mat-icon inline (click)="copylink()">content_copy</mat-icon>
    </div>

    <div class="ratios" *ngIf="data?.is_partner">
      <a (click)="viewRatio()">查看分成比例</a>
    </div>
  </div>

  <div class="spacer"></div>

  <div class="right">
    <div class="qrcode">
      <qrcode
        [qrdata]="sharelink()"
        [width]="108"
        [errorCorrectionLevel]="'M'"
        elementType="img"
        [margin]="2"
        [imageWidth]="256"
      ></qrcode>
    </div>
    <!-- <div>推广二维码</div> -->
  </div>
</mat-card>
